<template>
	<div>
		<router-view name="toolList"></router-view>
	</div>
</template>
<script>
export default {
	name: 'page-tools',
};
</script>
<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/pages/configuration/page-tools.vue